import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { valgReducer } from './Valg/Reducers';
import VeilederHounDto from '../Models/VeilederHounDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { satserReducer } from './Satser/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';

const rootReducer = combineReducers<VeilederHounAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederHounDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederHounDto>,
    ): EpiContext<VeilederHounDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    satser: satserReducer,
});

export type VeilederHounAppState = EpiAppStateMedSteg<VeilederHounDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>;
};

export default function configureStore(): Store<VeilederHounAppState> {
    const valgStateJson = window.localStorage.getItem('state');
    if (valgStateJson != null) {
        const savedState = JSON.parse(valgStateJson) as VeilederHounAppState;
        return createStore(rootReducer, savedState, applyMiddleware(ReduxThunk));
    }

    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
